import React from 'react';
import _ from 'lodash';
import { Card, Grid, Button } from 'semantic-ui-react';

import EmailInput from '../../EmailInput';
import ClaimSummary from '../../ClaimSummary';
import PathView from '../../PathView';
import Content from '../../Content';
import TaskContainer from '../../TaskContainer';
import getTaskTitle from '../../../utils/getTaskTitle';
import ConfirmationModal from '../../modals/ConfirmationModal';
import ErrorsList from './ErrorsList';

const TaskView = ({
  task,
  claim,
  loading,
  closeNoMessageModalOpen,
  onCloseNoMessage,
  paxReplyEmail,
  selectedTemplate,
  onClaimClosed,
  onEmailBodyChange,
  onMessageSend,
  children,
  onModalOpen
}) => {
  const { id, createdAt, priority, claimId } = task || '';
  const passengerEmail = _.get(claim, 'passengerTicket.passengerEmail', '');

  return (
    <Content fullWidth>
      <PathView
        paths={[
          { name: 'Tasks', path: '/tasks' },
          { name: id, path: `/task/${id}` }
        ]}
      />
      <ConfirmationModal
        question='This action will require manual documents review in claim view, are you sure?'
        isOpen={closeNoMessageModalOpen}
        onConfirmation={onCloseNoMessage}
      />
      <TaskContainer
        title={getTaskTitle(task)}
        date={createdAt}
        id={id}
        priority={priority}
        icon='hashtag'
        claimId={claimId}
        loading={loading}
        hideClaim={false}
        onClaimClosed={onClaimClosed}
      >
        <Card.Description>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <ClaimSummary claim={claim} />
                {claim && <ErrorsList claim={claim} />}
              </Grid.Column>
              <Grid.Column width={11}>
                <Grid>
                  <Grid.Row>
                    <EmailInput
                      recipientIconName='user'
                      recipient={passengerEmail}
                      recipientEditable={false}
                      subject='Missing Documents'
                      body={paxReplyEmail}
                      selectedTemplate={selectedTemplate}
                      onChange={onEmailBodyChange}
                    />
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        floated='right'
                        primary
                        content='Send'
                        onClick={onMessageSend}
                      />
                      <Button
                        floated='right'
                        primary
                        content='Close without sending Email'
                        name='closeNoMessageModalOpen'
                        onClick={onModalOpen}
                      />
                      {children}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
      </TaskContainer>
    </Content>
  );
};

export default TaskView;



// WEBPACK FOOTER //
// ./src/component/tasks/HandleUnsuccessfulLOAValidationTask/TaskView.js